import { create } from "zustand"

import { ParentTabNavOption } from "../../../types"

interface ParentTabNavStore {
  selectedTab: ParentTabNavOption
  setSelectedTab: (tab: ParentTabNavOption) => void
}

const useParentTabNavStore = create<ParentTabNavStore>((set) => ({
  selectedTab: ParentTabNavOption.HOME,
  setSelectedTab: (tab) => set({ selectedTab: tab }),
}))

export default useParentTabNavStore
